// Get Top Performers
export const GET_TOP_PERFORMERS_REQUEST = 'GET_TOP_PERFORMERS_REQUEST';
export const GET_TOP_PERFORMERS_DONE = 'GET_TOP_PERFORMERS_DONE';
export const GET_TOP_PERFORMERS_FAILED = 'GET_TOP_PERFORMERS_FAILED';
export const GET_TOP_PERFORMERS_RESET = 'GET_TOP_PERFORMERS_RESET';